import React, {useState, useEffect} from 'react';
import {Card, Checkbox, Grid, List, ListItem, ListItemText, Fab, CardActions, IconButton, CardContent, Typography, Divider, Button} from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import IosShareIcon from "@mui/icons-material/IosShare";
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import styles from '../../../assets/styles/modules/Bookmark.module.css'
import {deleteScrapNewsAPI, resetCategoryAPI} from "../../../apis/my_service";
import AddCategoryModal from "./AddCategoryModal";
import EmailModal from "./EmailModal";


const pageSize = 20;
const Bookmark = ({categoryBtnList, bookmarkList}) => {

    const [page, setPage] = useState(1);
    const [scrapeidx, setScrapeidx] = useState([]) // 선택한 뉴스 스크랩번호 저장
    const [modalOpen, setModalOpen] = useState(false)// 모달창 bool값 설정
    const [addOrMove, setAddOrMove] = useState('') // 뉴스 카테고리 분류 or 이동
    const [showEmailModal, setShowEmailModal] = useState(false)


    // 카테고리 분류 모달창 제어
    const addBtnClick = (type,bool) => {
        setAddOrMove('add',bool)
        setModalOpen(bool)
    };

    // 카테고리 이동 모달창 제어
    const moveBtnClick = (bool) => {
        setAddOrMove('move')
        setModalOpen(bool)
    };


    //카테고리에 할당된 뉴스 리셋
    const deleteCategory = (id, list) => {
        const newIdxList = list.map(el => el.scrapeidx)
        scrapeidx && scrapeidx.map((el) => {
            if (newIdxList.includes(Number(el))) {
                resetCategoryAPI(el).then(res => {console.log(res)})
            }
            else {
                alert('배정된 뉴스를 선택하세요')
            }
        })
        setTimeout(() => {window.location.reload()}, 500)
    };


    //뉴스 스크랩 취소(삭제)
    const deleteScrapNews = () => {
        scrapeidx && scrapeidx.map((idx) => {
            deleteScrapNewsAPI(idx)
                .then(res => {
                    if(res){window.location.reload()}
                })
        })
    };

    const emailModalToggle = () => {
        setShowEmailModal(!showEmailModal)
    }



    // 스크랩 뉴스 페이지 네이션
    const [paginatedPosts, setPaginatedPosts] = useState();

    useEffect(() => {
        setPaginatedPosts(bookmarkList.filter(el => el.categoryid === '0').slice(0, pageSize));
    }, [bookmarkList]);

    const pageCount = bookmarkList.filter(el => el.categoryid === '0') ? Math.ceil(bookmarkList.filter(el => el.categoryid === '0').length / pageSize) : 0;

    const pagination = (pageNo) => {
        setPage(pageNo);
        const startIndex = (pageNo - 1) * pageSize;
        const paginatedPost = bookmarkList.filter(el => el.categoryid === '0').slice(startIndex, startIndex + pageSize);
        setPaginatedPosts(paginatedPost);
    };


    return (
        <>
            <Grid className={styles.bookmarked_container} item sx={{width: '45%', overflow: 'hidden','&.MuiGrid-item':{paddingTop:'0'}}}>
                <Card sx={{boxShadow: 'none'}}>
                    <List dense component="div" role="list" sx={{height: 760}}>
                        {paginatedPosts && paginatedPosts.map((post, idx) =>
                                <ListItem key={idx} role='listitem' button>
                                    <Checkbox
                                        icon={<CheckCircleOutlineIcon/>} checkedIcon={<CheckCircleIcon/>}
                                        tabIndex={-1}
                                        color='error'
                                        inputProps={{'aria-labelledby': `transfer-list-item-${post.categoryid}-label`,}}
                                        value={post.scrapeidx}
                                        sx={{padding: '0', margin: "2px 0 3px 0",}}
                                        onClick={(e) => {
                                            if (e.target.checked) {
                                                setScrapeidx([...scrapeidx, e.target.value])
                                            } else {
                                                setScrapeidx(scrapeidx.filter(el => el !== e.target.value))
                                            }
                                        }}
                                    />
                                    <ListItemText id={post.categoryid} primary={post.headline} sx={{margin: '4px 0 0 10px', color: '#222',}}/>
                                </ListItem>
                        )}
                    </List>
                    <CardActions className={styles.card_footer}>
                        <IconButton
                            className={`${styles.muiBtn} prevBtn`} size="large"
                            onClick={() => {
                                setPage(page - 1)
                                pagination(page - 1)
                            }}
                            disabled={page === 1}>
                            <ArrowLeftIcon fontSize="inherit"/>
                        </IconButton>
                        {`${page}/${pageCount}`}
                        <IconButton
                            className={`${styles.muiBtn} nextBtn`} size="large"
                            onClick={() => {
                                setPage(page + 1)
                                pagination(page + 1)
                            }}
                            disabled={page === pageCount}>
                            <ArrowRightIcon fontSize="inherit"/>
                        </IconButton>
                        <div className={styles.btn_wrapper}>
                            <Button className={styles.categorize_btn} outline color="secondary" onClick={()=>addBtnClick('add', true)}>추가</Button>
                            <Button className={styles.categorize_btn}  outline color="secondary" onClick={() => deleteScrapNews(scrapeidx)}>삭제</Button>
                        </div>
                        <AddCategoryModal
                            categoryBtnList={categoryBtnList} modalOpen={modalOpen} setModalOpen={setModalOpen}
                            addBtnClick={addBtnClick} addOrMove={addOrMove} scrapeidx={scrapeidx}
                        />
                    </CardActions>
                </Card>
            </Grid>

            <Grid className={styles.categorized_container} item sx={{position: 'relative', padding:'0', '&.MuiGrid-item':{paddingTop:'0'}}}>
                {categoryBtnList && categoryBtnList.map((category) => {
                            const filteredNewsList = bookmarkList.filter(el => el.categoryid === category.categoryid);
                            const delCount = filteredNewsList.length - 10

                            if(delCount>0){
                                const delList = filteredNewsList.slice(-delCount)
                                deleteCategory('1', delList)
                                filteredNewsList.splice(0,delCount)
                            }

                            return (
                                <div key={category.categoryid}>
                                    <Card sx={{overflow: 'auto', boxShadow: 'none'}}>
                                        <CardContent>
                                            <List dense component="div" role="list">
                                                <Typography className='categoryName' gutterBottom variant="h5"
                                                            component="div">{category.categoryname}</Typography>
                                                {filteredNewsList.map((news) => (
                                                    <ListItem key={news.scrapeidx} sx={{padding: '0'}} role="listitem" button>
                                                        <Checkbox
                                                            icon={<CheckCircleOutlineIcon/>}
                                                            checkedIcon={<CheckCircleIcon/>}
                                                            color='error'
                                                            className='listItemCheckbox'
                                                            tabIndex={-1}
                                                            sx={{paddingLeft: '0',}}
                                                            value={news.scrapeidx}
                                                            onClick={(e) => {
                                                                if (e.target.checked) {

                                                                    setScrapeidx([...scrapeidx, e.target.value])
                                                                } else {
                                                                    setScrapeidx(scrapeidx.filter(el => el !== e.target.value))
                                                                }
                                                            }}
                                                        />
                                                        <ListItemText id={news.scrapeidx} primary={news.headline}/>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </CardContent>
                                        <CardActions className={styles.card_footer_right}>
                                            <IconButton className={styles.muiBtn} size="large" onClick={moveBtnClick}>
                                                <IosShareIcon/>
                                            </IconButton>
                                            <IconButton className={styles.muiBtn} size="large" onClick={() => deleteCategory(category.categoryid, filteredNewsList)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </CardActions>
                                    </Card>
                                    <Divider variant="middle"/>
                                </div>
                            )
                        }
                    )
                }
                <Fab className={styles.email_btn} variant="extended" color="error" onClick={emailModalToggle} sx={{position:'absolute'}}>메일로 공유하기</Fab>
                <EmailModal showEmailModal={showEmailModal} emailModalToggle={emailModalToggle} scrapeidx={scrapeidx}
                       // toastMsg={toastMsg}
                />
            </Grid>
        </>
    )
};

export default Bookmark;